import { Pipe, PipeTransform } from '@angular/core';
import { CourseFilterService } from '../_services/course-filter.service';
import { Course } from 'lms-api';

@Pipe({
  name: 'courseFilter'
})
export class CourseFilterPipe implements PipeTransform {

  constructor(private courseFilterService: CourseFilterService) {
    
  }

  transform(courses: Course[], ...args: any[]): any {
    if(courses == null || courses.length == 0) return false;
    let filterable = this.courseFilterService.filterCourseList(courses);
    return filterable;
  }

}
